export default __webpack_public_path__ + "static/media/sparkles-no-1.84ba8e00.mid";